module.exports = __webpack_public_path__ + "img/sidebar_water_meter.898fbdbe.svg";